import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { utcToLocal } from "commons/ultilities/date/dayjs";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { IAddEditWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";

export const useParchaseOrderValueChanged = ({
  getControl,
}: {
  getControl: (fieldName: keyof IAddEditWorkOrderPo) => IControl;
}) => {
  const { setProp: setStoreProp } = useStores();
  const onPurchaseOrderIdChanged = useCallback(
    async (value: string) => {
      try {
        setStoreProp("appFreeze", true);
        const res = await orderBusiness.getById(value);
        const purchaseOrderItemCtr = getControl("purchaseOrderItemId");
        purchaseOrderItemCtr.setValueAndValidate("");
        purchaseOrderItemCtr.setProp(
          "optionItems",
          res?.items?.map((x) => ({
            value: x.id,
            label: x.product?.name ?? "",
          })) ?? [],
        );

        getControl("dealingNameReadOnlyInfo")?.setValueAndValidate(
          res?.customer?.dealingName ?? "",
        );

        getControl("orderDateReadOnlyInfo")?.setValueAndValidate(
          res?.poDate ? utcToLocal(res.poDate) : "",
        );
      } finally {
        setStoreProp("appFreeze", false);
      }
    },
    [getControl, setStoreProp],
  );

  return {
    onPurchaseOrderIdChanged,
  };
};
